import './Templates.scss'
import { useNavigate, useSearchParams } from 'react-router-dom'
import React from 'react'
import { TemplateLookup } from '../../../models/TemplateLibrary'
import { TEMPLATE_TABS } from './TemplatesTab'
import { ClickNavigation } from '../../../components/NavigationWithSideBar/ClickNavigation'
import { TemplatesTabView } from './TemplatesTabView'

export const Templates = () => {
  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams()
  const activeCategoryId = searchParams.get('category') ?? TEMPLATE_TABS[0].key

  const onClick: (templateLookup: TemplateLookup) => void = (templateLookup) => {
    navigate(`/workspace/setup/templates/template/${templateLookup.id}`)
  }

  const handleSectionClick = (id: string) => {
    setSearchParams({ category: id }, { replace: true })
  }

  const sections = TEMPLATE_TABS.map((tab) => ({
    id: tab.key,
    label: <span className={'searchParams' in tab ? 'template-tab' : 'template-group'}>{tab.label}</span>,
    title: 'header' in tab ? tab.header : tab.label,
    disabled: !('searchParams' in tab),
    content: () => ('searchParams' in tab ? <TemplatesTabView templatesTab={tab} onClick={onClick} /> : null),
  }))

  return (
    <div className='d-flex gap-5 templates-tab-wrapper w-100'>
      <ClickNavigation
        className='w-100'
        sections={sections}
        defaultActiveSectionId={activeCategoryId}
        activeSectionId={activeCategoryId}
        onSectionClick={handleSectionClick}
      />
    </div>
  )
}
